// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"footer-module--footerContainer--3p8Zq","footerSocial":"footer-module--footerSocial--2zVwj","footerText":"footer-module--footerText--FAeLG"};